function ProjectDivider() {

  return (
    <div className="divider"></div>
  );
}

export default ProjectDivider;
